export class AccumulationPeriod {
	constructor() {
	}
} 
